import { ShieldCheck } from "lucide-react";

const POINTS = [
  { t: "Genuine product listings", d: "Every product on CityShor is listed by a KYC verified exhibitor. Counterfeit or misleading listings are removed immediately." },
  { t: "Transparent pricing", d: "MRP, discount, packaging (2 percent) and GST (18 percent) are shown separately at checkout. Shipping charges are calculated by pincode." },
  { t: "Clear refund and return policies", d: "A 5 day return window is available for unused items with original tags. Refunds are processed within 5 to 7 business days." },
  { t: "Accurate product descriptions", d: "Exhibitors are required to describe products truthfully including material, size, colour and specifications." },
  { t: "Customer support information", d: "WhatsApp support 9998238587. Email Hi@cityShor.com. Monday to Saturday, 11 AM to 7 PM IST." },
  { t: "Secure payment processing", d: "All payments are handled by Razorpay, or transferred directly to the Cityshor LLP AU Bank account. Card details never touch our servers." },
  { t: "No prohibited or restricted products", d: "CityShor does not allow the sale of alcohol, tobacco, drugs, weapons, adult products, hate symbols or any item restricted under Indian law." },
];

export default function MetaCommerce() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-14" data-testid="meta-commerce-page">
      <div className="text-xs uppercase tracking-[0.3em] text-[#F48E2E] font-bold mb-2">Policies</div>
      <h1 className="font-display text-4xl md:text-5xl mb-3">Meta Commerce Compliance</h1>
      <p className="text-gray-700 leading-relaxed mb-8">
        CityShor Pop-Up Bazaar (Ahmedabad) operates in compliance with the Meta Commerce Policies. The commitments listed below apply to every product page, every checkout, and every exhibitor on the platform.
      </p>
      <div className="space-y-3">
        {POINTS.map((p, i) => (
          <section key={i} className="p-5 bg-white rounded-2xl border border-gray-200 flex items-start gap-3">
            <div className="h-9 w-9 rounded-full bg-[#FEF3E6] flex items-center justify-center flex-shrink-0"><ShieldCheck className="h-4 w-4 text-[#F48E2E]" /></div>
            <div>
              <h2 className="font-display text-xl mb-1">{p.t}</h2>
              <p className="text-gray-700 leading-relaxed text-sm">{p.d}</p>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
